function InfoBoxRow({ children }) {
  return <div className="info-box">{children}</div>;
}
export default InfoBoxRow;
